require('../../sass/components/_formField.scss');


import {PasswordInput} from "./PasswordInput";
import {Input} from './Input';
import {InputWithSuffix} from './InputWithSuffix';
import {Select2} from './Select2';
import {Select} from './Select';
import {Textarea} from "./Textarea";
import {File} from "./File";

function hasValue(value) {
    if (value === null || value === undefined) {
        return false;
    }

    if (typeof value === 'string') {
        return value.length > 0;
    }

    if (typeof value === 'number') {
        return !isNaN(value);
    }
    return false;
}

const Custom = {
    name: 'Custom',
    template: `<div><slot></slot></div>`
};

export const FormFieldError = {
    name: 'FormFieldError',
    props: {
        messages: Array,
        message: String
    },
    computed: {
        allErrors() {
            const err = [];
            if (this.messages) {
                err.push(...this.messages.slice(0));
            }
            if (this.message) {
                err.push(this.message);
            }
            return err;
        }
    },
    template: `
    <div class="form-field__error" v-if="allErrors.length > 0">
        <div v-for="message in allErrors" class="form-field__error__message">
            {{message}}
        </div>
    </div>
`
};

export const FormField = {
    name: 'FormField',
    components: {
        PasswordInput,
        Input,
        InputWithSuffix,
        Select2,
        Select,
        Custom,
        FormFieldError,
        Textarea,
        File
    },
    props: {
        type: {
            type: String,
            default: 'text'
        },
        label: String,
        errorMessage: String,
        invalid: Boolean,
        disabled: Boolean,
        suffix: String,
        suffixWidth: [Number, String],
        description: String,
        descriptionAlign: String,
        value: [String, Number],
        options: {},
        settings: {},
        mask: [String, RegExp, Function],
        maskOptions: Object,
        mode: String,
        rules: Object,
        placeholder: String,
        pattern: String,
        min: Number,
        max: Number,
        step: Number,
        fileLabel: String,
        maxlength: [Number, String],
        name: String,
        noLabel: Boolean,
        indentErrors: Boolean,
        autocomplete: String,
        readonly: Boolean,
        raised: Boolean,
        inputmode: String,
        isHighlighted: Boolean,
    },
    data() {
        return {
            // id: 'field_' + Math.random(),
            id: !!this.name ? 'field_' + this.name : 'field_' + Math.random(),
            focused: false
        }
    },
    computed: {
        rootClasses() {
            const isLabelVisible = hasValue(this.value) || this.focused;
            return [
                'form-field',
                isLabelVisible ? 'form-field--label-visible' : undefined,
                this.errorMessage && 'form-field--invalid',
                this.isWithoutLabel && 'form-field--no-label',
                this.indentErrors && 'form-field--indented-errors',
                this.raised && 'form-field--raised'
            ];
        },
        isWithoutLabel() {
            if (this.noLabel) {
                return true;
            }
            return this.type === 'file';
        },
        component() {
            if (this.type === 'custom') {
                return 'Custom';
            }
            if (this.type === 'textarea') {
                return 'Textarea';
            }
            if (this.type === 'password') {
                return 'PasswordInput';
            }
            if (this.suffix) {
                return 'InputWithSuffix';
            }
            if (this.type === 'select') {
                return 'Select';
            }
            if (this.type === 'select2') {
                return 'Select2'
            }
            if (this.type === 'file') {
                return 'File';
            }
            return 'Input';
        },
        realPlaceholder() {
            return this.placeholder === undefined ? this.label : this.placeholder;
        },
        isInvalid() {
            return this.invalid || !!this.errorMessage
        },
        descriptionVisible() {
            return !this.isInvalid && !!this.description;
        }
    },
    methods: {
        onFocus() {
            this.focused = true;
        },
        onBlur() {
            this.focused = false;
        }
    },
    template: `
        <div v-bind:class="rootClasses">
            <component :is="component" 
                        class="form-field__control"
                        :id="id"
                        :placeholder="realPlaceholder" 
                        :isInvalid="isInvalid"
                        :disabled="disabled"
                        :suffix="suffix"
                        :suffixWidth="suffixWidth"
                        :type="type"
                        :name="name"
                        :value="value"
                        :fileLabel="fileLabel"
                        :options="options"
                        :settings="settings"
                        :mask="mask"
                        :rules="rules"
                        :mode="mode"
                        :step="step"
                        :min="min"
                        :max="max"
                        :is-highlighted="isHighlighted"
                        :readonly="readonly"
                        :pattern="pattern"
                        :maskOptions="maskOptions"
                        :maxlength="maxlength"
                        :autocomplete="autocomplete"
                        :inputmode="inputmode"
                        @focus="onFocus"
                        @blur="onBlur"
                        @input="$emit('input', $event)"
                        v-on="$listeners">
                    <slot></slot>
            </component>
            <label class="form-field__label" :for="id" v-if="!isWithoutLabel">{{ label }}</label>
            <FormFieldError :message="errorMessage"/>
            <span class="form-field__description" :data-align="descriptionAlign" v-if="descriptionVisible">{{description}}</span>
            <slot name="after"></slot>
        </div>
    `
};
